// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

// project imports
import Search from './Search';
import Notification from './Notification';
import Profile from './Profile';
import MobileSection from './MobileSection';
import { useAuth } from 'contexts/AuthContext';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { workspace } = useAuth();

  return (
    <>
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
      {!downLG && (
        <Chip
          label={workspace?.name || 'Liance workspace'}
          variant="outlined"
          sx={{
            borderRadius: '999px',
            borderColor: 'secondary.main',
            backgroundColor: 'common.white',
            color: 'text.secondary',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            fontSize: '0.68rem',
            height: 34
          }}
        />
      )}
      {!downLG && <Notification />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
